import {injectIntl} from 'react-intl';
import React from 'react';
import connect from "react-redux/es/connect/connect";
import FormComponent from "./forms/ChangeEmailForm.js";
import styles from './css/ProfileDetails.scss';
import {createSubmitAction} from "../../app/forms";
import {UPDATE_EMAIL, UPDATE_EMAIL_FAILURE, UPDATE_EMAIL_SUCCESS} from "../settings";
import {FormattedMessage} from "react-intl";
import Button from "../../../ui/Button";

@injectIntl
export class ChangeEmail extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            successful: false,
        }
    }

    render() {
        const { visible, successful } = this.state;

        if (successful) {
            return (
                <div className={styles.profile}>
                    <FormattedMessage id='frontend.profile.change_email.success' />
                </div>
            );
        }

        if (!visible) {
            return (
                <div className={styles.profile}>
                    <Button emphasis='default' onClick={() => this.setState({visible: true})}>
                        <FormattedMessage id='frontend.profile.change_email.title' />
                    </Button>
                </div>
            )
        }

        return (
            <div className={styles.profile}>
                <FormComponent
                    onSubmitSuccess={() => this.handleSuccess()}
                    onSubmit={createSubmitAction(
                        UPDATE_EMAIL,
                        UPDATE_EMAIL_SUCCESS,
                        UPDATE_EMAIL_FAILURE,
                    )}/>
            </div>
        );
    }

    handleSuccess() {
        this.setState({
            visible: false,
            successful: true,
        });
    }
}

export default connect(() => ({}))(ChangeEmail);
